<template>
    <div class="model_service_box">
        <div class="model_service_container">
            <div class="pc-title modeling_title" >
                <span class="pc-head modeling_head" >{{title}}</span>
                <span>下单后， <span class="change_color">ThingJS平台</span>工作人员 将尽快联系您<span v-if="step">（ {{step}} ）</span></span>
                <span class="layui-layer-setwin close_btn"  @click="hidePanel"><a class="layui-layer-ico layui-layer-close layui-layer-close1" href="javascript:;"></a></span>
            </div>
            <div class="modeling_content" style = "padding-left:0px">
                <div class="describe" v-if="fromType !== 'saleProject'">您自行建模上传、搭建3D场景，在本平台都是免费的。<br>
                    <div>您若需ThingJS平台提供模型定制服务（设施设备、建筑外观、倾斜摄影数据处理等），每个模型800元起。可填写下面资料发出申请，ThingJS平台会有专人联系您沟通服务细节。</div>
                </div>
                <div class="describe" v-if="fromType == 'saleProject'">
                    本项目可售卖。购买后可获得本项目3D场景、3D模型、脚本源码、界面UI等完整资源，可用于进一步开发完整应用。具体购买事项可联系客服，或致电官方电话：400-666-9832！
                </div>
                <div class="form_need form_item">
                    <div class="label_item">我需要<span class="must_item">*</span></div>
                    <div class="content_item">
                        <textarea class="textarea_need" name="" id="" v-model="needContent" @blur="checkNeedContent()"></textarea>
                    </div>
                </div>
                <div class="form_item" v-if="fromType !== 'saleProject'">
                    <div class="label_item">上传资料</div>
                    <div class="content_item" style="display: flex;flex-direction: row;">
                         <div class="">
                             <div class="upload_btn" @click="selectFiles()">选择文件</div>
                             <input id="upload_input" type="file"  @change="getFile($event)" multiple="multiple">
                         </div>
                         <div>
                                <div class="fileTip" v-show="!fileLen" >未选择任何文件</div>
                                <div class="fileTip" v-show="fileLen" style="display: flex;flex-direction: row;">已选择{{fileLen}}个文件,
                                    <div class="check" @click="checkFile()" >点击查看</div>
                                </div>

                        </div>
                    </div>
                </div>
                <div class="form_item" v-if="fromType !== 'saleProject'">
                    <div class="label_item">预算金额<span class="must_item">*</span></div>
                    <div class="content_item">
                         <div class="input_item">
                             <input type="text" placeholder="800" v-model="budget" @blur="checkBudget()">
                             <div class="unit">元</div>
                         </div>
                         <div class="error_tip" v-show="!(budget&&number) && budgetOnOff"><i class="fa  fa-exclamation-circle"></i> 请填写正确的预算</div>
                    </div>
                </div>
                <div class="form_item">
                    <div class="label_item">公司名称<span class="must_item">*</span></div>
                    <div class="content_item">
                         <div class="input_item campanyInfo">
                             <input type="text" placeholder="请输入公司名称" v-model="camName" @blur="checkCampany()">
                         </div>
                    </div>
                </div>
                <div class="form_item" style="display:flex;margin-left:56px;">
                    <div class="label_item">联系人<span class="must_item">*</span></div>
                    <div class="content_item" style="width:167px;">
                         <div class="input_item" style="width:167px;">
                             <input type="text" placeholder="请输入联系人" v-model="perName" @blur="checkName()">
                         </div>
                    </div>
                    <div class="label_item">职务<span class="must_item">*</span></div>
                    <div class="content_item">
                         <div class="input_item">
                            <input type="text" placeholder="请输入职务" v-model="perJob" @blur="perJobOnOff = true,checkOffice()">
                         </div>
                    </div>
                </div>
                <div class="form_item">
                    <div class="label_item">微信号<span class="must_item">*</span></div>
                    <div class="content_item">
                         <div class="input_item input_info netInfo">
                             <input type="text" placeholder="请输入微信号" v-model="weixin" @blur="contactOnOff = true">
                         </div>
                    </div>
                </div>
                <div class="form_item">
                    <div class="label_item">手机号码<span class="must_item">*</span></div>
                    <div class="content_item">
                        <div class="input_item phone_number">
                            <input type="text"  placeholder="请输入手机号" v-model="phoneNumber" @blur="checkPhoneNumber()">
                        </div>
                        <div class="write_code">
                            <input type="text" placeholder="请填写验证码" v-model="code">
                        </div>
                        <div class="send_code" v-show="!sending" :class="sendState" @click="sendCode()">发送验证码</div>
                        <div class="send_code no_send" v-show="sending">{{time}}s后可重新获取</div>
                    </div>
                </div>
                <div class="form_item make_order">
                    <div class="label_item"></div>
                    <div class="content_item">
                        <div class="submit" @click="makeOrder()">立即下单</div>
                    </div>
                </div>
            </div>
            <div class="model_service_box" v-show="orderSuccess">
                <div class="order_success_container">
                    <div class="order_success_title" >
                        <span class="pc-head">提示</span>
                        <span class="layui-layer-setwin"  @click="closeSuccessBox()"><a class="layui-layer-ico layui-layer-close layui-layer-close1" href="javascript:;"></a></span>
                    </div>
                    <div class="order_seccess_content">申请成功，请在“ThingJS网站”-“我的订单”中查看处理进度。</div>
                    <div class="footer_box" >
                        <div class="submit_btn submit" @click="checkOrder()">查看订单</div>
                        <Button style="top: -1px;position: relative;"  @click="closeSuccessBox()">关闭</Button>
                    </div>
                </div>
            </div>
            <div class="model_service_box" v-show="orderError">
                <div class="order_success_container">
                    <div class="order_success_title" >
                        <span class="pc-head"> 提示</span>
                        <span class="layui-layer-setwin"  @click="closeErrorBox()"><a class="layui-layer-ico layui-layer-close layui-layer-close1" href="javascript:;"></a></span>
                    </div>
                    <div class="order_seccess_content">{{orderError}}</div>
                    <div class="footer_box" >
                        <Button style="top: -1px;position: relative;"  @click="closeErrorBox()">关闭</Button>
                    </div>
                </div>
            </div>
            <div class="model_service_box" v-show="isFile">
                <div class="order_success_container">
                    <div class="order_success_title" >
                        <span class="pc-head"> 查看文件</span>
                        <span class="layui-layer-setwin"  @click="closeErrorBox()"><a class="layui-layer-ico layui-layer-close layui-layer-close1" href="javascript:;"></a></span>
                    </div>
                    <div  v-show="fileLen" class="fileList" >
                                <span class="fileTip" v-for="(item,i) in fileName"  v-show="fileLen" style="display: flex;justify-content: space-between;margin-bottom: 3px;line-height: 26px;">{{item}}
                                    <button class="upload_btn" style="border-color: transparent;line-height: 0px; outline: 1px dotted;min-width: 48px;" @click="deleteFiles(i)">删除</button>
                                </span>
                    </div>
                    <div v-show="!fileLen" class="order_seccess_content" >未选择任何文件</div>
                    <div class="footer_box" >
                        <Button style="top: -1px;position: relative;"  @click="closeErrorBox()">关闭</Button>
                    </div>
                </div>
            </div>
            <div  class="model_service_box loading_box" v-show="loading">
                <Button loading shape="circle" type="primary" style="background:#ff6110;border-color: #ff6110;"></Button>
            </div>
        </div>
    </div>
</template>
<script>
import bus from '../assets/js/eventBus.js';
export default {
    name: "modeling_box",
    data: function() {
        return{
            mmdId:'',
            sendState:"ok_send",
            phoneNumber:"",
            phoneNumberOk:true,
            time:60,
            sending:false,
            needContent:"建模",
            needContentOk:true,
            files:'',
            code:'',
            budget:'',
            budgetOnOff:false,
            number:1,
            weixin:'',
            contactOnOff:false,
            fileLen:0,
            fileName:[],
            makeAnOrder:true,
            orderSuccess:false,
            orderError:"",
            loading:false,
            camName:'',
            camNameOnOff:false,
            perName:'',
            perNameOnOff:false,
            perJob:'',
            perJobOnOff:false,
            uid:'',
            currentPhone:'',
            fromType:'',
            title:'申请建模',
            step:'',
            token:'',
            currentUrl:'',// 留资页面定位url地址
            finallyList: '',
            isFile:false,
            isclicked:false,
            id:''
        }
    },
    methods: {
        checkOrder:function(){
            this.closeSuccessBox();
            window.open('https://www.thingjs.com/guide/?m=sample', '我的订单');
        },
        closeErrorBox:function(){
            this.orderError = false;
            this.isFile = false;
        },
        closeSuccessBox:function(){
            this.orderSuccess = false;
            this.hidePanel(true);
        },
        hidePanel:function(success){
            if(success){
                this.$emit('hidePanel',success);
                this.$emit('hidePanelD',success);
            }else{
                this.$emit('hidePanel');
                this.$emit('hidePanelD');
            }
            this.step = '';
            window.parent.postMessage('close','*');
        },
        checkBudget:function(){
            var reg = /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/;
            if(reg.test(this.budget)){
                if(this.budget>=800){
                    this.budgetOnOff = true;
                }else{
                    this.budgetOnOff = false;
                    this.orderError = "预算金额不得小于800元"
                }
            }else{
                this.budgetOnOff = false;
                this.orderError = "请输入正确的预算金额"
            }

        },
        detectInput:function(inputVal,title){
            inputVal=inputVal||'';
            let reg=/[\\\/：:？*?"<>|]/m;
            if(reg.test(inputVal)){
                return title+'不能包含特殊字符 如\\\/:*?"<>|';
            }
            return '';
        },
        checkCampany:function(){
            var reg = /^[\(\)\（\）\u4E00-\u9FA5A-Za-z\s]{2,}$/;
            let checkCampanyName=this.camName;
            let acceptCampanyName= this.detectInput(checkCampanyName,'公司名称');
            if(acceptCampanyName) return  this.orderError=acceptCampanyName;
            if(reg.test(this.camName)){
                this.camNameOnOff = true;
            }else{
                this.camNameOnOff = false;
                this.orderError = "公司名称至少为2个字符，且不包含数字"
            }
        },
        checkName:function(){
            var reg = /^[\u4E00-\u9FA5A-Za-z\s]{2,}$/;
            let checkPerName=this.perName;
            let acceptPerName= this.detectInput(checkPerName,'联系人');
            if(acceptPerName) return  this.orderError=acceptPerName;
            if(reg.test(this.perName)){
                this.perNameOnOff = true;
            }else{
                this.perNameOnOff = false;
                this.orderError = "联系人至少为2个字符，且不包含数字"
            }
        },
        checkOffice:function(){
            let checkPerJob=this.perJob;
            let acceptPerJob= this.detectInput(checkPerJob,'职务');
            if(acceptPerJob) return  this.orderError=acceptPerJob;
        },
        // checkPhoneNum:function(){
        //     var reg = /^1[0-9]{10}$/; //验证规则
        //     if( reg.test(this.phoneNumber)){
        //         this.phoneNumberOk = true;
        //     }else{
        //         this.phoneNumberOk = false;
        //     }
        // },
        checkPhoneNumber:function(){
            var reg = /^1[0-9]{10}$/; //验证规则
            if( reg.test(this.phoneNumber)){//匹配成功
                this.sendState = "ok_send";
                this.phoneNumberOk = true;
            }else{
                this.phoneNumberOk = false;
                this.sendState = "no_send";
                this.orderError = "请输入正确的手机号"
            }
        },
        checkNeedContent:function(){
            if(this.needContent == ""){
                this.needContentOk = false;
                this.orderError = "填写的内容不少于一个字"
            }else{
                this.needContentOk = true;
            }
        },
        doubleCheckPhone:function(){//手机号查重
            var _this = this;
            if(this.phoneNumber == this.currentPhone){//发送验证码
                _this.sendCode();
            }else{
                this.$reqs.get("/modeling/doubleCheckPhone?_ajax=true&phoneNumber="+this.phoneNumber, {}).then(function(result) {
                    if(result.data.code == 500){
                        _this.orderError = "该手机号已被占用，请重新输入";
                    }else{
                        _this.sendCode();
                    }
                }).catch(function(error) {
                     _this.orderError = "获取验证码失败";
                });
            }
        },
        getFile:function(event){
            this.fileName = [];
            this.files = event.target.files;
            if(this.files.length < 10){
                this.fileLen = this.files.length;
            }else{
                this.fileLen = 10;
            }
            for(var i=0;i<this.fileLen; i++){
                this.fileName.push(this.files[i].name)
            }
            $(".btn-none").addClass("fileTip");
            $(".btn-none").removeClass("btn-none");
        },
        selectFiles:function(){
            this.fileLen = 0;
            this.isclicked  = false;
            $("#upload_input").val("");
            $("#upload_input").click();
        },
        sendCode:function(){
            if(!this.phoneNumber){return;}
            this.$reqs.get("/modeling/getPhoneVCode?_ajax=true&phoneNumber="+this.phoneNumber, {}).then(function(result) {
                    if(result.data && result.data.success) {
                        //  console.log(result.data);
                    } else {
                        _this.orderError = result.data.msg;
                    }
                }).catch(function(error) {
                     _this.orderError = "获取验证码失败";
                });

            this.sending = true;
            this.time = 60;
            var _this = this
            var timer = setInterval(function(){
                _this.time = _this.time - 1;
                if(_this.time == 0){
                    _this.sending = false;
                    clearInterval(timer);
                }
            }, 1000)
        },
        submiteOrder:function(urlListStr){
            var _this = this;
            var uid = this.mmdId?this.mmdId:$.cookie('mmdId');
            var params = {
                "userid":uid,
                "demand":this.needContent,
                "file":urlListStr,
                "code":this.code,
                "budget":this.budget,
                "number":this.number,
                "phone":this.phoneNumber,
                "weixin":this.weixin,
                "camName":this.camName,
                "perName":this.perName,
                "perJob":this.perJob,
                "paySource": this.currentUrl
            }
            this.loading = true;
            let isMmdidLegitimate;
            try{
                isMmdidLegitimate = this.$global.AntiSqlValid(uid);
            }catch(e){
                isMmdidLegitimate = true;
            }
            if(isMmdidLegitimate){
                this.$reqs.post("/modeling/modelApply",params,{timeout: 20000}).then(function(result){
                    _this.loading = false;
                    if(result.data && result.data.success){//下单成功
                        _this.orderSuccess = true;
                        _this.sendOrderByRobot(params,"model");
                        window.AnalysysAgent && window.AnalysysAgent.track('apply_for_modeling',{'buyName': '申请建模下单成功'})
                    }else if(result.data && !result.data.success){
                        _this.orderError = result.data.msg;
                    }
                }).catch(function(error) {
                    _this.loading = false;
                    _this.orderError = "网络繁忙，请重试！";
                });
            }
        },
        submitFile:function(){
            var _this = this;
            var formData = new FormData();
            var len = this.files.length;
            var url = "/modeling/uploadFile"
            if(self!=top) {
                url="/modeling/uploadFile?id="+_this.id;
            }
            if(len > 10){//最多传10个附件
                len = 10;
            }
            if(this.finallyList || this.isclicked) {
                 if(!this.finallyList){
                     _this.submiteOrder("");
                 }
                this.$reqs.post(url,this.finallyList,).then(function(result){
                var urlListStr = '';
                if(result.data && result.data.state){
                    for(var i = 0; i < result.data.content.length; i++){
                        if(urlListStr){
                            urlListStr += ","+result.data.content[i];
                        }else{
                            urlListStr += result.data.content[i];
                        }
                    }
                }
                _this.submiteOrder(urlListStr);
            }).catch(function(error) {
                console.log("上传附件失败"+error);
                _this.submiteOrder("");
            });
            }else {
                for(var i = 0; i < len; i++){

                formData.append(i,this.files[i]);
            }
            this.$reqs.post(url,formData,).then(function(result){
            var urlListStr = '';
            if(result.data && result.data.state){
                for(var i = 0; i < result.data.content.length; i++){
                        if(urlListStr){
                            urlListStr += ","+result.data.content[i];
                        }else{
                            urlListStr += result.data.content[i];
                        }
                    }
                }
                _this.submiteOrder(urlListStr);
            }).catch(function(error) {
                console.log("上传附件失败"+error);
                _this.submiteOrder("");
            });
            }




        },
        makeOrder:function(){
            var _this = this;
            this.makeAnOrder = true;
            this.loading = true;
            // if(this.needContent && this.budget && this.number && this.phoneNumber && this.weixin && this.camName && this.perName && this.perJob && this.code){
            if(this.needContent && this.budgetOnOff && this.number && this.phoneNumberOk && this.weixin && this.camNameOnOff && this.perNameOnOff && this.perJob && this.code){
                if(this.files.length){
                    this.submitFile();
                }else{
                    this.submiteOrder('');
                }
            }else{
                this.loading = false;
                if(!this.needContent){
                    this.orderError = "请填写建模需求"
                }else if(!this.budget || !this.budgetOnOff){
                    this.orderError = "请正确填写您的预算"
                }else if(!this.camName || !this.camNameOnOff){
                    this.orderError = "公司名称至少为2个字符，且不包含数字"
                }else if(!this.perName || !this.perNameOnOff){
                    this.orderError = "联系人至少为2个字符，且不包含数字"
                }else if(!this.perJob){
                    this.orderError = "请正确填写职务"
                }else if(!this.weixin){
                    this.orderError = "请填写您的微信"
                }else if(!this.phoneNumberOk || !this.phoneNumber){
                    this.orderError = "请输入正确的手机号码"
                }else if(!this.code){
                    this.orderError = "请填写验证码"
                }
                console.log("请填写完整");
            }
        },
        getUserInfo:function(){
            var _this = this;
            var url="/user/User_info?token="+($.cookie('token')||_this.token);
            if(self!=top) {
                url=url+"&mmdid="+this.mmdId;
            }
            let isMmdidLegitimate;
            try{
                isMmdidLegitimate = this.$global.AntiSqlValid(this.mmdId);
            }catch(e){
                isMmdidLegitimate = true;
            }
            if(isMmdidLegitimate){
                this.$reqs.get(url).then(function(result) {
                    _this.perJob = result.data.office;
                    _this.camName = result.data.company;
                    _this.phoneNumber = result.data.phoneVerify;
                    _this.perName = result.data.namebyCam;
                    _this.perNameOnOff = _this.perName?true:false;
                    _this.id = result.data.id;
                    var reg = /^[\(\)\（\）\u4E00-\u9FA5A-Za-z\s]{2,}$/;
                    if(reg.test(_this.camName)){
                        _this.camNameOnOff = true;
                    }else{
                        _this.camNameOnOff = false;
                    }
                }).catch(function(error) {
                    console.log(error);
                });
            }
        },
        sendOrderByRobot:function(params,type){
            if(type)params.type = type;
            this.$reqs.post("/modeling/sendByRobot",params,{timeout: 20000}).then(function(result){
                console.log("转发成功！");
            }).catch(function(error) {
                console.log("消息发送失败："+error);
            });
        },
        init:function (data){
            if(data && data.toolInfo){
                var msg = data.toolInfo;
                this.fromType = msg.subject;
                this.needContent = msg.projectName+"("+msg.url+")";
                this.budget = 2000;
                this.budgetOnOff = true;
                this.perNameOnOff = true;
                this.mmdId = data.mmdId;
                this.title="项目购买";
                this.currentUrl=data.currentUrl
            }else{
                this.fromType = '';
                this.needContent="建模";
                this.title='申请建模';
                this.budget = '';
                this.budgetOnOff = false;
                this.token=data&&data.token?data.token:'';
                this.currentUrl=data.currentUrl
            }
            this.step = data?data.step:'';
            this.getUserInfo();

        },
        deleteFiles(num) {
            this.fileName.splice(num, 1);
            this.isclicked  = true;
            var fileList = new FormData();
            var len = this.files.length;
            this.fileLen = this.fileLen-1;
            if(this.finallyList) {
                for(num; num<len; num++) {
                    var filevalue = this.finallyList.get(num+1);
                    this.finallyList.set(num, filevalue);
                }
                if(this.finallyList.get(0) === "null") {
                this.finallyList='';
                }
                return;
            }
            for(var i = 0; i < len; i++){
                fileList.append(i,this.files[i]);
            }
            // fileList.delete(num);
            for(num; num<len; num++) {
                var filevalue = fileList.get(num+1);
                fileList.set(num, filevalue);
            }
            this.finallyList = fileList;
            if(this.finallyList.get(0) === "null") {
                this.finallyList='';
            }
            // var a = this.finallyList.get(0);
            // var b = this.finallyList.get(1);
            // var c = this.finallyList.get(2);
            // var d = this.finallyList.get(3);
            // console.log(a);
            // console.log(b);
            // console.log(c);
            // console.log(d);
        },
        checkFile() {
            this.isFile = true;
        }
    },
    mounted(){
        var _this = this;
        this.mmdId = this.$route.query.userId;
        window.addEventListener("message", function(event) {
            if(event.data == "fixed"){
                 $('.model_service_container').css({
                    'top':'0','left':'0','transform':'none'
                 })
            }
            if(event.data.showModel){
                _this.init(event.data.info)
            }
        })

        bus.$on('panelShowModel', (data) => {
            this.init(data.infos);
        })

        if(self == top){
            _this.currentUrl = window.location.href
        }
    }
}
</script>
<style lang="">
    @import '../assets/css/modelService.css';
</style>



// WEBPACK FOOTER //
// src/components/ModelService.vue